import { get, find } from './modules/scene';
import { queueAnimation, removeAnimation } from './modules/animation';

export function startAutoRotate(store) {
  const player = get(store, { scene: true, evalPlug: 'Player' });
  const id = player && player.autoRotateNode;

  if (!player || !player.autoRotate || !id) return false;

  const increment = player.autoRotateDirection === '+' ? 360 : -360;
  const path = find(store, { id, plug: 'Transform', property: 'rotation' });
  const rotation = get(store, { id, plug: 'Transform', property: 'rotation' });

  if (path && rotation) {
    store.dispatch(queueAnimation({
      name: 'autoRotate',
      autoplay: true,
      iterations: Infinity,
      easingDuration: 3000,
      tracks: [{
        path,
        start: 0,
        duration: player.autoRotateSpeed * 1000,
        value: { x: rotation.x, y: rotation.y + increment, z: rotation.z },
      },],
    }));
  }
};

export function stopAutoRotate(store) {
  store.dispatch(removeAnimation('autoRotate'));
};

export function autoRotateTool(store) {
  let startingTimeout;

  const tool = {
    start: (timeout=5000) => {
      startingTimeout = setTimeout(() => {
        startAutoRotate(store);
      }, timeout);
    },

    stop: ()  => {
      stopAutoRotate(store);
      clearTimeout(startingTimeout);
    },

    mousedown: () => tool.stop(),
    mouseup: () => tool.start(),
  };

  return {
    enabled: true,
    tool,
  };
};



// WEBPACK FOOTER //
// ./src/autoRotate.js